/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The second line of a Markdown table sets each column's alignment: :--- is left, :--: is center, ---: is right, and --- leaves it unset.`)
};

const es_mt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La segunda línea de una tabla Markdown establece la alineación de cada columna: :--- es izquierda, :---: es centro, ---: es derecha, y --- la deja sin establecer.`)
};

const de_mt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die zweite Zeile einer Markdown-Tabelle bestimmt die Ausrichtung jeder Spalte: :--- bedeutet links, :--: bedeutet zentriert, ---: bedeutet rechts, und --- lässt sie ungesetzt.`)
};

const nl_mt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De tweede regel van een Markdown-tabel bepaalt de uitlijning van elke kolom: :--- is links, :---: is centrum, ---: is rechts, en --- laat het ongesteld.`)
};

const fr_mt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La deuxième ligne d'un tableau Markdown définit l'alignement de chaque colonne : :--- est gauche, :--: est centre, ---: est droite, et --- le laisse non défini.`)
};

const it_mt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La seconda riga di una tabella Markdown imposta l'allineamento di ogni colonna: :--- è sinistra, :--: è centro, ---: è destra, e --- lo lascia non impostato.`)
};

const pt_br2_mt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A segunda linha de uma tabela Markdown define o alinhamento de cada coluna: :--- é esquerda, :---: é centro, ---: é direita, e --- deixa indefinido.`)
};

const pt_mt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A segunda linha de uma tabela Markdown define o alinhamento de cada coluna: :--- é esquerda, :---: é centro, ---: é direita, e --- deixa-o indefinido.`)
};

const ja_mt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown テーブルの 2 番目の行は各列の配置を設定します。:--- は左、:--: は中央、---: は右、--- は設定されていない状態です。`)
};

const zh_mt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown 表格的第二行用于设置每列的对齐方式：:--- 表示左对齐，:--: 表示居中对齐，---: 表示右对齐，--- 则不设置对齐方式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_faq1_a", locale)
	if (locale === "en") return en_mt_faq1_a(inputs)
	if (locale === "es") return es_mt_faq1_a(inputs)
	if (locale === "de") return de_mt_faq1_a(inputs)
	if (locale === "nl") return nl_mt_faq1_a(inputs)
	if (locale === "fr") return fr_mt_faq1_a(inputs)
	if (locale === "it") return it_mt_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_mt_faq1_a(inputs)
	if (locale === "pt") return pt_mt_faq1_a(inputs)
	if (locale === "ja") return ja_mt_faq1_a(inputs)
	return zh_mt_faq1_a(inputs)
};